// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--tmrO3","info-block":"_02712f2b3b--info-block--TZUhu","link":"_02712f2b3b--link--Fn8Aw"};